import { lazy } from 'react';

// project imports
import MainLayout from 'jsx/layout/MainLayout';
import Loadable from 'jsx/components/utilities/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// employee routes
const Dashboard = Loadable(lazy(() => import('jsx/views/admin/Dashboard/Dashbord1')));
const Dashboard2 = Loadable(lazy(() => import('jsx/views/admin/Dashboard/DashBoard2')));
const Dashboard3 = Loadable(lazy(() => import('jsx/views/admin/Dashboard/DashBoard3')));
const SupportTickets = Loadable(lazy(() => import('jsx/views/admin/SupportTickets')));
const AccountProfile = Loadable(lazy(() => import('jsx/views/admin/AdminUsers/AccountProfile')));
const ChangePassword = Loadable(lazy(() => import('jsx/pages/authentication/auth-forms/ChangePassword')));


const CsTechnicalRoutes = {
    path: '/cs-technical',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'dashboard-2', element: <Dashboard2 /> },
        { path: 'dashboard-3', element: <Dashboard3 /> },
        { path: 'support-tickets', element: <SupportTickets /> },
        { path: 'account/profile', element: <AccountProfile /> },
        { path: 'change-password', element: <ChangePassword /> }
    ]
};

export default CsTechnicalRoutes;
